export const getAgentsUrl = (workspaceId: string) => `/business/workspaces/${workspaceId}/agents`;

export const getAgentUrl = (workspaceId: string, id: string | number) =>
  `/business/workspaces/${workspaceId}/agents/${id}`;

export const getIndustriesUrl = () => '/business/industries';

export const getAgentTemplatesUrl = (workspaceId: string) => `/business/workspaces/${workspaceId}/agent_templates`;

export const getAgentTemplateUrl = (workspaceId: string, id: string) =>
  `/business/workspaces/${workspaceId}/agent_templates/${id}`;

export const getAgentDataSetsUrls = (workspaceId: string, agentId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/datasets`;

export const getAgentDataSetUrls = (workspaceId: string, agentId: string, id: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/datasets/${id}`;
